import template from './spending-type.html';
import controller from './spending-type.controller';

let spendingTypeComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default spendingTypeComponent;
